import { render, staticRenderFns } from "./IcoArrowTop.vue?vue&type=template&id=e45951bc"
import script from "./IcoArrowTop.vue?vue&type=script&lang=js"
export * from "./IcoArrowTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports